import axios from 'axios';
import { showMessage } from 'app/store/actions/fuse';
import { API_BASE_URL } from '@config';

export const SET_LDAP_SERVERS = 'SET_LDAP_SERVERS';
export const SET_LDAP_ERROR = 'SET_LDAP_ERROR';

export const setLdapServers = (data) => ({
  type: SET_LDAP_SERVERS,
  payload: data,
});

export const setLdapError = (data) => ({
  type: SET_LDAP_ERROR,
  payload: data,
});

export const getLdapServers = (organizationId) => (dispatch) => {
  let url = `${API_BASE_URL}/api/ldap/servers`;
  if (organizationId !== undefined && organizationId !== null) {
    url += `?organizationId=${organizationId}`;
  }
  return axios
    .get(url)
    .then((response) => {
      dispatch(setLdapServers(response.data));
    })
    .catch((err) => {
      dispatch(setLdapError({ ...err.response, type: 'modal' }));
    });
};

export const updateLdapServer = (server, organizationId) => (dispatch) => {
  if (server.admin_password === '') delete server.admin_password
  const url = `${API_BASE_URL}/api/ldap/servers/${server.id}`;
  return axios
    .patch(url, server)
    .then(() => {
      dispatch(showMessage({ message: 'LDAP Server Updated Successfully' }));
      dispatch(getLdapServers(organizationId));
    })
    .catch((err) => {
      dispatch(setLdapError({ ...err.response, type: 'modal' }));
    });
};

export const addLdapServer = (server, organizationId) => (dispatch) => {
  const payload = { ...server };
  if (organizationId !== undefined && organizationId !== null) {
    payload.organizationId = organizationId;
  }
  const url = `${API_BASE_URL}/api/ldap/servers`;
  return axios
    .post(url, payload)
    .then(() => {
      dispatch(showMessage({ message: 'LDAP Server Added Successfully' }));
      dispatch(getLdapServers(organizationId));
    })
    .catch((err) => {
      dispatch(setLdapError({ ...err.response, type: 'modal' }));
    });
};

export const deleteLdapServer = (id, organizationId) => (dispatch) => {
  const url = `${API_BASE_URL}/api/ldap/servers/${id}`;
  return axios
    .delete(url)
    .then(() => {
      dispatch(showMessage({ message: 'LDAP Server Deleted Successfully' }));
      dispatch(getLdapServers(organizationId));
    })
    .catch((err) => {
      dispatch(setLdapError({ ...err.response, type: 'modal' }));
    });
};
